import { useCallback, useEffect, useState } from "react";
import {
  Button,
  NewTable,
  NewTableAdv,
  TableAdv,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import { usePagination } from "../../../../../hooks";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { formatCurrency } from "../../../../../utils/stringUtils";
import { exactUTCDate } from "../../../../../utils/dateFormator";
import { useNavigate } from "react-router-dom";
const Previouspaydetails = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    payData: [],
    totalCount: 0,
  });
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid,
  );

  const { page, limit, setPage, handleLimitChange } = usePagination(10);

  const PreviouspaydetailsColumns = [
    { key: "clientName", label: "Client Name" },
    { key: "payCycle", label: "Pay Cycle" },
    { key: "payRate", label: "Pay Rate" },
    { key: "hours", label: "Total Hours" },
    { key: "grossPay", label: "Gross Pay" },
    { key: "deductions", label: "Deductions" },
    { key: "health", label: "Health" },
    { key: "otherPayment", label: "Other Payment" },
    { key: "secondProjectAmount", label: "Second Project Amount" },
    { key: "referral", label: "Referral" },
    { key: "payrollAmount", label: "Payroll Amount" },
    { key: "paidOn", label: "Paid On" },
  ];

  // if (mappedRows.length === 0) return <NoData />
  const fetchPreviousPayDetails = useCallback(
    async (page, limit) => {
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PAYROLL.GET_ALL,
          params: {
            coll: "Payroll",
            pg: page,
            lim: limit,
            ref: "PlacementWithClient",
            incl: "payments jobInfo.billClient",
            fil: JSON.stringify({
              employeeId: {
                type: "NONE",
                value: employeeProfileUiid,
              },
              status: {
                type: "NONE",
                value: 4,
              },
            }),
          },
        });
        return response?.data?.data || [];
      } catch (error) {
        console.error("Error fetching Previous Payment data:", error);
        return [];
      }
    },
    [page, limit],
  );

  const fetchPreviousPayDetailsTotalCount = useCallback(async () => {
    try {
      const response = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.PAYROLL.GET_TOTAL_COUNT,
        params: {
          coll: "Payroll",
          fil: JSON.stringify({
            employeeId: {
              type: "NONE",
              value: employeeProfileUiid,
            },
            status: {
              type: "NONE",
              value: 4,
            },
          }),
        },
      });
      return response?.data?.data || [];
    } catch (error) {
      console.error("Error fetching Previous Payment data:", error);
      return [];
    }
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchPreviousPayDetails(page, limit);
      const total = await fetchPreviousPayDetailsTotalCount();
      console.log({ total });
      const mappedData = res.map((item) => {
        const lastPayment =
          item?.jobId?.payments?.[item?.jobId?.payments?.length - 1] || {};
        let totalrefrralAmount =
          lastPayment?.referral
            ?.map((empRef) => {
              let effective =
                Math.round(
                  lastPayment?.billRate?.rate *
                    (1 - (lastPayment?.vmsCharges ?? 0) / 100) *
                    100,
                ) / 100;
              const calculateReferralAmount = empRef?.margin
                ? empRef?.referralAmount
                : empRef?.referralAmountType === 2
                  ? effective * (empRef?.referralAmount / 100)
                  : empRef?.referralAmountType === 1
                    ? empRef?.referralAmount
                    : empRef?.referralAmount;
              return calculateReferralAmount;
            })
            ?.reduce((a, b) => a + b, 0) || 0;
        return {
          clientName: item?.jobId?.jobInfo?.billClient?.businessName || "-",
          payCycle:
            exactUTCDate(item?.payCycle?.from) +
              " - " +
              exactUTCDate(item?.payCycle?.to) || "-",
          payRate: lastPayment?.payRate?.payRatePerHour || "-",
          hours: item?.timesheets?.totalHrs || "-",
          grossPay: formatCurrency(item?.timesheets?.totalPay) || "-",
          // deductions: item?.deductions || "-",
          deductions:
            formatCurrency(item?.amounts?.diff - item?.amounts?.insurance) ||
            "-",
          health: formatCurrency(item?.amounts?.insurance) || "-",
          otherPayment:
            formatCurrency(
              item?.otherPays?.payrollAmount
                ? item?.otherPays?.payrollAmount
                : item?.bonuses?.totalPay,
            ) || "-",
          secondProjectAmount:
            formatCurrency(item?.timesheets?.totalUnpaid) || "-",
          referral: formatCurrency(item?.totalrefrralAmount) || "-",
          payrollAmount: formatCurrency(item?.amounts?.netPay) || "-",
          paidOn: item.paymentInfo?.on
            ? exactUTCDate(item.paymentInfo?.on)
            : "-",
        };
      });

      setData({ payData: mappedData, totalCount: total });
    };
    fetchData();
  }, [fetchPreviousPayDetails, page, limit]);
  console.log({ mapper: data.payData });
  const mappedRows = mapTableRows(data.payData, PreviouspaydetailsColumns);

  return (
    <div className="relative overflow-hidden flex-1 flex">
      <div className="mt-4 flex-1 flex overflow-hidden">
        <TableAdv
          columns={PreviouspaydetailsColumns}
          rows={mappedRows}
          serverPagination={true}
          totalCount={data?.totalCount || 0}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
            add: [
              {
                component: (
                  <Button
                    onClick={() => navigate("/employee/payroll/activities")}
                    title={"Activities"}
                    size="sm"
                    variant={"outlined"}
                  />
                ),
              },
            ],
            order: ["add", "search"],
          }}
        />
      </div>
      {/* <div></div> */}
    </div>
  );
};

export default Previouspaydetails;
